import { getErrorMessageFromErrorType } from '@flowwai-frontend/shared/utils/common'

import { VerifyOtpForUpdatingUserPinMutation as Mutation } from './mutation.generatedTypes'

interface ResponseArgsType {
   data: Mutation
   onFailure?: (
      errorMessage: string,
      data: Mutation['verifyOtpForUpdatingUserPin']
   ) => void
   onSuccess?: () => void
}

interface ReturnType {
   handleAPIResponse: (args: ResponseArgsType) => void
}

const useAPIResponseHandler = (): ReturnType => {
   const handleAPIResponse = (args: ResponseArgsType): void => {
      if (!args.data) return
      const { verifyOtpForUpdatingUserPin } = args.data

      switch (verifyOtpForUpdatingUserPin.__typename) {
         case 'VerifyOtpForUpdatingUserPinResult': {
            args.onSuccess?.()
            break
         }
         case 'InvalidOTP':
         case 'OTPIsExpired':
         case 'OTPLengthMismatched':
         case 'OTPMaxRetriesExceeded':
         default: {
            const errorType = verifyOtpForUpdatingUserPin.__typename
            const apiErrorMessage =
               'message' in verifyOtpForUpdatingUserPin
                  ? verifyOtpForUpdatingUserPin.message
                  : null
            const errorMessage =
               apiErrorMessage ?? getErrorMessageFromErrorType(errorType)

            args.onFailure?.(errorMessage, verifyOtpForUpdatingUserPin)
         }
      }
   }
   return { handleAPIResponse }
}

export default useAPIResponseHandler
